import { Box, Container } from '@mui/material';
import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import Page from '../../components/Page';
import AnalyticsSidebar from '../../components/analyticsSidebar';
import useResponsive from '../../hooks/useResponsive';

export default function Analytics() {
    const [isOpen, setIsOpen] = useState(true);
    const smDown = useResponsive('down', 'sm');

    useEffect(() => {
        if(smDown){
            setIsOpen(false);
        }
    }, [smDown]);

    return (
        <Page title="Analytics" margin="0px">
            <Box sx={{ display: 'flex' }}>
                <AnalyticsSidebar isOpen={isOpen} setIsOpen={setIsOpen} />
                <Box
                    component="main"
                    sx={ (theme) => ({
                        flexGrow: 1,
                        ml: isOpen ? '280px' : '70px',
                        p: '24px 0',
                        transition: 'margin-left 0.3s',
                        [theme.breakpoints.down('sm')]: {
                            ml: isOpen ? '263px' : '65px',
                            p: '16px 0',
                        },
                    })}
                >
                    <Container maxWidth="xl">
                        <Outlet />
                    </Container>
                </Box>
            </Box>
        </Page>
    );
}
